<!--
Copyright 2023 The Ground Authors.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

<div
  class="submission-panel"
  [ngClass]="{ loading: isLoading() || isDeleting() }"
>
  <div *ngIf="isLoading() || isDeleting()" class="progress-spinner">
    <mat-spinner mode="indeterminate" diameter="50"></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading() && !isDeleting()">
    <div class="submission-panel-header">
      <div class="submission-panel-header-left">
        <button mat-icon-button (click)="navigateToSubmissionList()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <div class="submission-panel-header-title">
          {{ submission()?.created?.user?.displayName }}
        </div>
      </div>
      <button
        mat-icon-button
        *ngIf="canDeleteSubmission()"
        [matMenuTriggerFor]="menu"
        aria-label="Submission options"
        i18n-aria-label="@@app.submissionPanel.options"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="deleteSubmission()">
          <mat-icon>delete</mat-icon>
          <span i18n="@@app.submissionPanel.deleteSubmission"
            >Delete submission</span
          >
        </button>
      </mat-menu>
    </div>
    <div class="submission-subtitle">
      <span>
        {{ submission()?.lastModified?.clientTime | date: 'longDate' }}
      </span>
      <span>&nbsp;&bull;&nbsp;</span>
      <span>
        {{ submission()?.lastModified?.clientTime | date: 'shortTime' }}
      </span>
    </div>
    <div *ngIf="tasks" class="submission-tasks-container">
      <div *ngFor="let task of submittedTasks(); let i = index">
        @let result = getTaskSubmissionResult(task);
        <mat-divider *ngIf="i > 0"></mat-divider>
        <div class="submission-task">
          <div class="submission-question">{{ task.label }}</div>
          <div class="submission-response">
            @if (result?.skipped) {
              <div class="submission-no-response">
                <ng-container i18n="@@app.submissionPanel.skipped"
                  >Skipped</ng-container
                >
              </div>
            } @else if (task.type === taskType.MULTIPLE_CHOICE) {
              <submission-multiple-choice-view
                [task]="task"
                [selection]="asMultipleSelection(result!)"
              ></submission-multiple-choice-view>
            } @else if (task.type === taskType.PHOTO) {
              <submission-photo-view
                [path]="asString(result!)"
              ></submission-photo-view>
            } @else if (
              task.type === taskType.DROP_PIN ||
              task.type === taskType.CAPTURE_LOCATION ||
              task.type === taskType.DRAW_AREA
            ) {
              <submission-geometry-view
                [task]="task"
                [geometry]="asGeometry(result!)"
                [displayIndex]="i + 1"
                [jobColor]="submission()?.job?.color"
                [isSelected]="task.id === selectedTaskId"
                (selected)="selectGeometry(task)"
              ></submission-geometry-view>
            } @else if (task.type === taskType.DATE) {
              <submission-date-view
                [date]="asDate(result!)"
              ></submission-date-view>
            } @else if (task.type === taskType.TIME) {
              <submission-time-view
                [time]="asDate(result!)"
              ></submission-time-view>
            } @else if (
              task.type === taskType.TEXT ||
              task.type === taskType.NUMBER ||
              task.type === taskType.DATE_TIME
            ) {
              <submission-text-view
                [text]="asStringOrNumber(result!)"
              ></submission-text-view>
            }
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
